import * as z from 'zod'
import { taskStatusZ } from '../schema'

export const bookingStatusParamsZ = z.object({ taskId: z.string() })
export type BookingStatusParams = z.infer<typeof bookingStatusParamsZ>

export const bookingStatusZ = taskStatusZ.extend({
  result: z
    .object({
      prettyId: z.string().optional(),
      error: z.string().optional(),
      url: z.string().optional(),
      payment: z
        .object({
          intentId: z.string(),
          scaIframeUrl: z.string().nullable(),
          status: z.string(),
        })
        .optional(),
      signature: z.string().optional(),
    })
    .nullable(),
})

export type BookingStatus = z.infer<typeof bookingStatusZ>

export const bookingStatusEndpoint = z
  .function()
  .args(bookingStatusParamsZ)
  .returns(z.promise(bookingStatusZ))
